import { render, staticRenderFns } from "./MandarinPrediction.vue?vue&type=template&id=a0ab8294&scoped=true&"
import script from "./MandarinPrediction.vue?vue&type=script&lang=js&"
export * from "./MandarinPrediction.vue?vue&type=script&lang=js&"
import style0 from "./MandarinPrediction.vue?vue&type=style&index=0&id=a0ab8294&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ab8294",
  null
  
)

export default component.exports